"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stretch;
var _reactDom = require("@floating-ui/react-dom");
function stretch() {
  return (0, _reactDom.size)({
    apply(_ref) {
      let {
        rects,
        elements
      } = _ref;
      Object.assign(elements.floating.style, {
        minWidth: `${rects.reference.width}px`
      });
    }
  });
}